export default {
  description: 'Usa el código: {{code}} para disfrutar de un descuento en tus próximos {{count}} pedidos aquí.',
  discounts: {
    percentage: '{{discount}}%',
    fixed: '{{discount}}',
  },
  list: {
    item: {
      order: '{{orderNumber}}. Pedido',
    },
  },
  savings: {
    percentage: 'Ahorras un total de {{totalSaved}}%',
    fixed: 'Ahorras un total de {{totalSaved}}',
  },
  apply: 'Aplicar',
  applied: 'Aplicado',
  remove: 'Eliminar',
  custom_button: {
    done: 'Listo',
  },
};
